module.exports = __webpack_public_path__ + "img/logo-ufuf-2.82c50ba3.png";